// import Layout from "../../components/Layout/Layout";
import PageTitle from "../../../components/PageTitle";
import Button from "../../../components/Button";
// import useStyles from "./styles";
import { useState, useEffect } from "react";
import TabContext from "@mui/lab/TabContext";
import { useNavigate, Link } from "react-router-dom";
import { Tooltip } from "@mui/material";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import Tabs from "@mui/lab/TabList";
import AllSubject from "./AllSubject";
import { toast } from "react-toastify";
import { httprequest } from "../../../data/api";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import { Icon } from "@iconify/react";
import { useUserState } from "../../../context/UserContext";
import { accessViewAssignmentById } from "../../../data/roles";
import Layout from "../../../components/Layout";

const CLASS_ENDPOINT = "/api/v1/teacher/classes";
const SUBJECT_IN_CLASS_ENDPOINT = "api/v1/teacher/subjects";
const CLASS_SUBJECT = "api/v1/teacher/class-subject";

const EmployeeSubject = () => {
  const { userRole } = useUserState();
  // const classes = useStyles();
  const navigate = useNavigate();
  const [value, setValue] = useState("1");
  const [classesData, setAllClassesData] = useState([]);
  const [subjectByClass, setSubjectByClass] = useState([]);
  const [subjectResultByClass, setSubjectResultByClass] = useState([]);

  const subjectColumns = [
    {
      name: "Subject",
      selector: row => row?.subject?.name
    },
    {
      name: "Date Created",
      selector: row => row?.created_at?.substring(0, 10)
    },
    {
      name: "Date Updated",
      selector: row => row?.updated_at?.substring(0, 10)
    },
    {
      name: "",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <Link to={`/subjects/subject-result/${row?.subject?.id}?class_id=${row?.class?.id}`}>
            <Tooltip title="View Subject Result" arrow placement="top">
              <button className="table-action-icon">
                <Icon icon="fluent:eye-16-regular" />
              </button>
            </Tooltip>
          </Link>
          <Link to="/lesson-notes">
            <Tooltip title="Lesson Notes" arrow placement="top">
              <button className="table-action-icon">
                <Icon icon="ri:newspaper-line" />
              </button>
            </Tooltip>
          </Link>
          <Link to={`/class-activities/employee/syllabus/${row?.subject?.id}?class_id=${row?.class?.id}`}>
            <Tooltip title="Syllabus" arrow placement="top">
              <button className="table-action-icon">
                <Icon icon="ph:book-open-text-light" />
              </button>
            </Tooltip>
          </Link>
        </div>
      )
    }

  ];

  // --| This is to get all the classes i am teaching as a teacher.
  // --| This is useful for populating the tabs and the tab panel
  const getClassByTeacher = () => {
    httprequest.get(`${CLASS_ENDPOINT}`).then((res) => {
      setAllClassesData(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  // --| This is to get a teacher's subject by class
  const getSubjectsByClass = (param) => {
    const endpoint =
    param === 1 || param === null
      ? SUBJECT_IN_CLASS_ENDPOINT
      : `${CLASS_SUBJECT}/${param}`;

    httprequest
      .get(endpoint)
      .then((res) => {
        setSubjectByClass(res?.data?.data);
        setSubjectResultByClass(res?.data?.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong");
      });
  };

  const handleChange = (_event, newValue) => {
    setValue(newValue);
    getSubjectsByClass(newValue);
  };

  useEffect(() => {
    getClassByTeacher();
  }, []);

  // --| Filter Subject table using name, email and class
  const handleSearchSubjectByClass = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = subjectByClass?.filter((data) => valArray?.every(
      (word) => data?.subject_name
        ?.toLowerCase()
        .includes(word.toLowerCase())
    )
    );
    setSubjectResultByClass(result);
  };

  return (
    <Layout children={
      <>
        <PageTitle
          title="My Subjects"
          subtitle="See the details of the Subject you take."
          button={
            accessViewAssignmentById(userRole) &&
            <Button onClick={() => navigate("/assignments")} variant="primary" buttonSize="small" color="btndefault" buttonName="Assignments" />

          }
        />
        <div className="page-content">
          <TabContext value={value}>
            <div className="tablist-container padding-left-16">
              <Tabs
                className="overide-tablist"
                onChange={handleChange}
                aria-label=""
              >
                <Tab label="All" value="1" />
                {classesData?.map((data) => {
                  return (
                    <Tab key={data?.class?.id} value={data?.class?.id} label={data?.class?.name} />
                  );
                })}
              </Tabs>
            </div>
            <TabPanel sx={{ padding: "0px !important" }} value="1" className="tabpanel-overide"><AllSubject /></TabPanel>
            {classesData?.map((data) => {
              return (
                <TabPanel sx={{ padding: "0px !important" }} key={data?.class?.id} value={data?.class?.id}>
                  <Table data={subjectResultByClass} columns={subjectColumns} subHeader={true} pagination subHeaderComponent={
                    <TableSearch placeholder="Search here..." searchTableFunc={handleSearchSubjectByClass} />}
                  />
                </TabPanel>
              );
            })}
          </TabContext>
        </div>
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default EmployeeSubject;
